export const ROW_GUTTER = 1;

export const ANTD_TOTAL_SPAN = 24;

// Always the left part:
export const SETTING_LEFT_SPAN = 10;

// Second part for 2-part setting row:
export const SETTING_RIGHT_SPAN = 14;

// Second and third part for 3-part setting row:
export const SETTING_MIDDLE_SPAN = 10;
export const SETTING_VALUE_SPAN = 4;
